export default __webpack_public_path__ + "static/media/Armbands of Rapturous Battle.7db69ff8.jpg";